import { makeStyles } from '@material-ui/styles'

export const useBalanceStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  title: {
    lineHeight: 1,
    fontWeight: 700,
    color: theme.palette.wallet.titleColor,
    fontSize: theme.typography.pxToRem(16),
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.75),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      gap: theme.spacing(1.5),
      flexWrap: 'wrap',
    },
  },
  enableWalletContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    justifyContent: 'center',
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      flexDirection: 'row',
    },
  },
  walletIcon: {
    '&.material-icons': {
      fontSize: theme.typography.pxToRem(47),
      color: theme.palette.wallet.balance.textColor,
    },
  },
  eyeButtonIcon: {
    borderRadius: '100%',
    boxShadow: theme.shadows[2],
    padding: theme.spacing(0.5, 1),
    width: theme.typography.pxToRem(32),
    height: theme.typography.pxToRem(32),
    '& .material-icons': {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.wallet.balance.textColor,
    },
  },
  groupedBalanceContainer: {
    display: 'flex',
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      flexWrap: 'wrap',
    },
  },
  balanceContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    justifyContent: 'center',
    padding: theme.spacing(2.5),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      width: '100%',
    },
    '&[data-display="none"]': {
      display: 'none',
    },
  },
  amountContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    justifyContent: 'space-between',
  },
  symbol: {
    lineHeight: 1,
    fontWeight: 400,
    float: 'inline-start',
    marginRight: theme.spacing(1.25),
    fontSize: theme.typography.pxToRem(14),
  },
  amount: {
    lineHeight: 1,
    fontWeight: 600,
    textWrap: 'nowrap',
    fontSize: theme.typography.pxToRem(28),
    color: theme.palette.wallet.balance.textColor,
  },
  chevronIcon: {
    '&.material-icons': {
      fontSize: theme.typography.pxToRem(24),
      color: theme.palette.wallet.balance.textColor,
    },
    '&[data-display="none"]': {
      display: 'none',
    },
  },
  balanceLabel: {
    lineHeight: 1,
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.wallet.balance.textColor,
  },
}))
